rdefine('app/products/properties/BaseProp',['backbone',
    'app/products/properties/Info',
        'app/products/properties/Section',
        'app/products/properties/Website',
        'app/products/properties/Floorplan',
        'app/products/properties/PicturesVR',
        'app/products/properties/Pdf',
        'app/products/properties/latlon',
        'app/products/properties/selectbox',
        'app/products/properties/timebox',
        'app/products/properties/qrcode',
        'app/products/properties/color',
        'app/products/properties/QRAction',
        'app/products/properties/Youtube',
        'app/products/properties/cards',
        'app/products/properties/AR',
        'app/products/properties/Formular',
        'app/products/properties/playlist',
        'app/products/properties/Boolean',
        'app/products/properties/Price'
    ],
    function(Backbone,Info,Section,Website,Floorplan,PicturesVR,Pdf,latlon,selectbox,timebox, QRCode, ColorChoice, QRAction, Youtube, Cards, AR, Formular, Playlist, pBoolean, Price) {
    return Backbone.Ribs.View.extend({
        prop:null,
        bindings:{
            el:{
              toggle:{
                  data:['model.one_lang','lmodel.language'],
                  processor:function(a,l) { return l==='de' ? true : !a; }
              }
            },
            '.control-label-parent':{
                text:{
                    data:'model.name',
                    processor:function(name) {
                        return name+":";
                    }
                }
            }
        },
        initialize:function(options) {
            this.lmodel = options.lmodel;
            if(this.model.has("section")) {
                this.$el.html('<p class="m-b-0 m-t-25 c-black f-500">'+this.model.get("section")+'  <span class="help-section" data-src=""><i class="zmdi zmdi-help"></i></span></p>');
                return;
            }

            this.$el.html('<div class="form-group relative-it">\n' +
                '    <label class="col-sm-2 control-label control-label-parent">:</label>\n' +
                '    <div class="col-sm-10">\n' +
                '        <div class="fg-line"></div></div></div>');
            console.log(this.model.get("propertystyle_id") );

            if(this.model.get("propertystyle_id") === 15) {
                var clink = $("#qr-code-toggle a").attr("href");
                this.$el.find(".form-group").append('<div class="deep-qr-button"><a href="#qr-code-toggle-'+this.model.get("id")+'" data-toggle="toggle-qr" data-target="qr-code-toggle"><i class="far fa-qrcode"></i></a><div id="qr-code-toggle-'+this.model.get("id")+'" class="content-of-button qr-code-toggle-cls" style="display: none">\n' +
                    '        <i class="far fa-qrcode"></i>\n' +
                    '        <div class="contet-qr-code"></div>\n' +
                    '        <div class="toggle-label">\n' +
                    '            <a href="'+clink+'#prop_'+this.model.get("id")+'">'+clink+'#prop_'+this.model.get('id')+'</a>\n' +
                    '        </div>\n' +
                    '    </div></div>');

                this.$el.find(".toggle-label a").on("click", function (e) {
                    e.preventDefault();
                    const el = document.createElement('textarea');
                    el.value = $(this).text();
                    document.body.appendChild(el);
                    el.select();
                    document.execCommand('copy');
                    document.body.removeChild(el);
                    SuccessMessage(LANGUAGE['clipboard-copied']);
                    $("#qr-code-toggle-"+this.model.get("id")).fadeOut(100);
                    Opened = false;
                    return false;
                });

                setTimeout(function(){

                    console.log(this.$el.find('.contet-qr-code')[0]);

                var qrCode=new window.QRCode(this.$el.find('.contet-qr-code')[0],{
                    text:clink+'#prop_'+this.model.get('id'),
                    width: 640,
                    height: 640,
                    colorDark : "#000000",
                    colorLight : "#ffffff",
                    correctLevel : 0
                });
                }.bind(this),1200);
            }

             var opt = {
                 model:options.model,
                 cform:options.cform,
                 lmodel:options.lmodel,
                 product_id:options.product_id
             };


            setTimeout(function(){
                switch(this.model.get('propertystyle_id')) {
                    case 1://info
                        this.prop = new Info(opt);
                        break;
                    case 2://section
                        this.prop = new Section(opt);
                        break;
                    case 3://	Website
                        this.prop = new Website(opt);
                        break;
                    case 4://	Floorplan
                        this.prop = new Floorplan(opt);
                        break;
                    case 5://	PicturesVR
                        this.prop = new PicturesVR(opt);
                        break;
                    case 6://	Pdf
                        this.prop = new Pdf(opt);
                        break;
                    case 7://	latlon
                        this.prop = new latlon(opt);
                        break;
                    case 8://	selectbox
                        this.prop = new selectbox(opt);
                        break;
                    case 9://	timebox
                        this.prop = new timebox(opt);
                        break;
                    case 10:
                        this.prop = new QRCode(opt);
                        break;
                    case 11:
                        this.prop = new ColorChoice(opt);
                        break;
                    case 12:
                        this.prop = new QRAction(opt);
                        break;
                    case 13:
                        this.prop = new Youtube(opt);
                        break;
                    case 14:
                        this.prop = new Cards(opt);
                        break;
                    case 15:
                        this.prop = new AR(opt);
                        break;
                    case 16:
                        this.prop = new Formular(opt);
                        break;
                    case 17:
                        this.prop = new Playlist(opt);
                        break;
                    case 18:
                        this.prop = new pBoolean(opt);
                        break;
                    case 19:
                        this.prop = new Price(opt);
                        break;
                }
                if(this.prop) {
                    this.$el.find(".fg-line").append(this.prop.el);
                }
            }.bind(this),0);
        }
    });
});